import type { Components, Theme } from "@mui/material";

export const MuiListSubheader: Components<Theme>["MuiListSubheader"] = {
  styleOverrides: {
    root: {
      fontWeight: 700,
    },
  },
};
